import React from 'react'
import './ContactUs.sass'
import { YMaps, Map, Placemark } from 'react-yandex-maps'
import Icon from '../../ui/Icon/Icon'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import ContactUsForm from './ContactUsForm/ContactUsForm'
import ContactUsPopUp from './ContactUsPopUp'

function ContactUs() {
  return (
    <section id="contacts" className="ContactUs DefaultSection">
      <ContactUsPopUp />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <SectionTitle title="Контакты" />
            <div className="ContactUs-Container">
              <div className="ContactUs-Info">
                <div className="ContactUs-Links">
                  <ContactUsInfoTile
                    icon="mobile"
                    data={<a href="tel:+79318016611">+7 (931) 801-66-11</a>}
                    description="Viber, Telegram, Whatsapp"
                  />
                  <ContactUsInfoTile icon="clock" data="Круглосуточно, 24/7" />
                  <ContactUsInfoTile
                    icon="envelope"
                    data="iterra.hotel@yandex.ru"
                  />
                  <ContactUsInfoTile
                    icon="link"
                    data={
                      <div className="SocialIcons">
                        <a href="https://vk.com/iterra_hotel" target="blank">
                          <Icon name="vk" weight="brand" />
                        </a>
                      </div>
                    }
                  />
                </div>
                <div className="ContactUs-Map">
                  <YMaps>
                    <Map
                      className="Map"
                      defaultState={{
                        center: [68.95963204942609, 33.102181499999986],
                        zoom: 16,
                      }}
                    >
                      <Placemark
                        geometry={[68.95963204942609, 33.102181499999986]}
                        options={{ preset: 'islands#greenIcon' }}
                      />
                    </Map>
                  </YMaps>
                </div>
              </div>
              {/* <ContactUsForm /> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

function ContactUsInfoTile({ icon, data, description }) {
  return (
    <div className="ContactUsInfoTile">
      <div className="ContactUsInfoTile-Icon">
        <Icon name={icon} weight="solid" />
      </div>
      <div className="ContactUsInfoTile-Data">
        <p className="Data">{data}</p>
        {description && <p className="Description">{description}</p>}
      </div>
    </div>
  )
}
export default ContactUs
